/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import { useThree, useFrame } from '@react-three/fiber'

export function IrusModel(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/models/IRUS.glb')
  const { actions } = useAnimations(animations, group)
  const scene = useThree(state => state.scene)

  // Three.js only writes the envMapIntensity uniform when a material program is
  // refreshed (program switch / material id change). For a static model that never
  // changes materials, that refresh never happens after the first compile, so the
  // uniform stays at whatever scene.environmentIntensity was when the GLB first
  // loaded — which is ENV_WARMUP_VALUE (0.0001), not the active intensity.
  //
  // Fix: keep each material's own envMapIntensity property in sync with the scene.
  // Three.js reads material.envMapIntensity directly into the uniform every frame
  // for MeshStandardMaterial, regardless of whether refreshMaterial is true.
  const lastEnvIntensityRef = useRef(null)
  useFrame(() => {
    const current = scene.environmentIntensity
    if (current === lastEnvIntensityRef.current) return
    lastEnvIntensityRef.current = current
    Object.values(materials).forEach(m => { m.envMapIntensity = current })
  })
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="Solar_Panel_Bracket000"
          castShadow
          receiveShadow
          geometry={nodes.Solar_Panel_Bracket000.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, 0.003, -0.031]}
          rotation={[Math.PI, 0, 0]}
          scale={0.928}
        />
        <mesh
          name="Solar_Panel_Bracket001"
          castShadow
          receiveShadow
          geometry={nodes.Solar_Panel_Bracket001.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, -0.003, -3.073]}
          scale={0.928}
        />
        <mesh
          name="Solar_Panel_Bracket002"
          castShadow
          receiveShadow
          geometry={nodes.Solar_Panel_Bracket002.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, 0.003, 1.126]}
          rotation={[Math.PI, 0, 0]}
          scale={0.928}
        />
        <mesh
          name="Big_Spike000"
          castShadow
          receiveShadow
          geometry={nodes.Big_Spike000.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, 0.003, -0.001]}
          rotation={[Math.PI, 0, 0]}
        />
        <mesh
          name="Big_Spike002"
          castShadow
          receiveShadow
          geometry={nodes.Big_Spike002.geometry}
          material={materials.M_Small_Parts}
          position={[-0.494, 0.076, -0.192]}
          rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
        />
        <mesh
          name="Small_Nubbin000"
          castShadow
          receiveShadow
          geometry={nodes.Small_Nubbin000.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, 0.003, -0.001]}
          rotation={[Math.PI, 0, Math.PI / 4]}
        />
        <mesh
          name="Small_Nubbin001"
          castShadow
          receiveShadow
          geometry={nodes.Small_Nubbin001.geometry}
          material={materials.M_Small_Parts}
          position={[-0.957, 0.003, -0.001]}
          rotation={[Math.PI, 0, Math.PI / 4]}
        />
        <mesh
          name="Small_Nubbin002"
          castShadow
          receiveShadow
          geometry={nodes.Small_Nubbin002.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, 0.696, -0.001]}
          rotation={[Math.PI, 0, Math.PI / 4]}
        />
        <mesh
          name="Small_Nubbin003"
          castShadow
          receiveShadow
          geometry={nodes.Small_Nubbin003.geometry}
          material={materials.M_Small_Parts}
          position={[-0.957, 0.696, -0.001]}
          rotation={[Math.PI, 0, Math.PI / 4]}
        />
        <mesh
          name="Small_Nubbin004"
          castShadow
          receiveShadow
          geometry={nodes.Small_Nubbin004.geometry}
          material={materials.M_Small_Parts}
          position={[0.505, 0.003, -0.014]}
          rotation={[0, 0, -2.356]}
        />
        <mesh
          name="Small_Nubbin005"
          castShadow
          receiveShadow
          geometry={nodes.Small_Nubbin005.geometry}
          material={materials.M_Small_Parts}
          position={[0.163, 0.003, -0.014]}
          rotation={[0, 0, -2.356]}
        />
        <mesh
          name="Small_Nubbin006"
          castShadow
          receiveShadow
          geometry={nodes.Small_Nubbin006.geometry}
          material={materials.M_Small_Parts}
          position={[0.505, 0.696, -0.014]}
          rotation={[0, 0, -2.356]}
        />
        <mesh
          name="Small_Nubbin007"
          castShadow
          receiveShadow
          geometry={nodes.Small_Nubbin007.geometry}
          material={materials.M_Small_Parts}
          position={[0.163, 0.696, -0.014]}
          rotation={[0, 0, -2.356]}
        />
        <mesh
          name="Large_Nubbin000"
          castShadow
          receiveShadow
          geometry={nodes.Large_Nubbin000.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, 0.003, -0.001]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          name="Large_Nubbin001"
          castShadow
          receiveShadow
          geometry={nodes.Large_Nubbin001.geometry}
          material={materials.M_Small_Parts}
          position={[0.152, 0.003, -0.015]}
          rotation={[Math.PI / 2, 0, -Math.PI]}
        />
        <mesh
          name="Front_Large_Ant000"
          castShadow
          receiveShadow
          geometry={nodes.Front_Large_Ant000.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, 0.003, -0.001]}
          rotation={[Math.PI, 0, Math.PI / 2]}
          scale={[0.045, 0.012, 0.045]}
        />
        <mesh
          name="Front_Large_Ant001"
          castShadow
          receiveShadow
          geometry={nodes.Front_Large_Ant001.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, 0.144, -0.001]}
          rotation={[Math.PI, 0, Math.PI / 2]}
          scale={[0.045, 0.012, 0.045]}
        />
        <mesh
          name="Front_Large_Ant002"
          castShadow
          receiveShadow
          geometry={nodes.Front_Large_Ant002.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, 0.003, -0.263]}
          rotation={[Math.PI, 0, Math.PI / 2]}
          scale={[0.045, 0.012, 0.045]}
        />
        <mesh
          name="Front_Large_Ant003"
          castShadow
          receiveShadow
          geometry={nodes.Front_Large_Ant003.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, 0.144, -0.263]}
          rotation={[Math.PI, 0, Math.PI / 2]}
          scale={[0.045, 0.012, 0.045]}
        />
        <mesh
          name="Little_Spike000"
          castShadow
          receiveShadow
          geometry={nodes.Little_Spike000.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, 0.003, -0.001]}
          rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
        />
        <mesh
          name="Little_Spike001"
          castShadow
          receiveShadow
          geometry={nodes.Little_Spike001.geometry}
          material={materials.M_Small_Parts}
          position={[-0.663, 0.225, -0.09]}
          rotation={[Math.PI, 0, 0]}
        />
        <mesh
          name="Big_Spike005"
          castShadow
          receiveShadow
          geometry={nodes.Big_Spike005.geometry}
          material={materials.M_Small_Parts}
          position={[-0.419, -0.248, -0.079]}
          rotation={[Math.PI, 0, -0.436]}
        />
        <mesh
          name="Little_Spike002"
          castShadow
          receiveShadow
          geometry={nodes.Little_Spike002.geometry}
          material={materials.M_Small_Parts}
          position={[-0.051, -0.367, -0.09]}
          rotation={[Math.PI, 0, -1.92]}
        />
        <mesh
          name="Big_Spike004"
          castShadow
          receiveShadow
          geometry={nodes.Big_Spike004.geometry}
          material={materials.M_Small_Parts}
          position={[0.347, -0.018, -0.001]}
          rotation={[Math.PI, 0, Math.PI]}
        />
        <mesh
          name="Little_Spike003"
          castShadow
          receiveShadow
          geometry={nodes.Little_Spike003.geometry}
          material={materials.M_Small_Parts}
          position={[0.395, -0.24, -0.09]}
          rotation={[Math.PI, 0, Math.PI]}
        />
        <mesh
          name="Big_Spike001"
          castShadow
          receiveShadow
          geometry={nodes.Big_Spike001.geometry}
          material={materials.M_Small_Parts}
          position={[0.452, -0.175, -0.009]}
          rotation={[Math.PI, 0, -2.705]}
        />
        <mesh
          name="Big_Spike003"
          castShadow
          receiveShadow
          geometry={nodes.Big_Spike003.geometry}
          material={materials.M_Small_Parts}
          position={[0.41, 0.076, -0.152]}
          rotation={[-Math.PI / 2, 0, -2.793]}
        />
        <mesh
          name="Little_Spike004"
          castShadow
          receiveShadow
          geometry={nodes.Little_Spike004.geometry}
          material={materials.M_Small_Parts}
          position={[0.38, 0.003, -0.376]}
          rotation={[-Math.PI / 2, 0, -2.793]}
        />
        <mesh
          name="Front_Spike"
          castShadow
          receiveShadow
          geometry={nodes.Front_Spike.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, 0.003, -0.001]}
          rotation={[-Math.PI / 2, 0.262, Math.PI / 2]}
        />
        <mesh
          name="45_Angled_Panel000"
          castShadow
          receiveShadow
          geometry={nodes['45_Angled_Panel000'].geometry}
          material={materials.M_Small_Parts}
          position={[0.557, -0.554, -0.373]}
        />
        <mesh
          name="45_Angled_Panel001"
          castShadow
          receiveShadow
          geometry={nodes['45_Angled_Panel001'].geometry}
          material={materials.M_Small_Parts}
          position={[0.567, -0.554, 0.367]}
          rotation={[0, 0, -Math.PI]}
          scale={-1}
        />
        <mesh
          name="Angled_Panel000"
          castShadow
          receiveShadow
          geometry={nodes.Angled_Panel000.geometry}
          material={materials.M_Small_Parts}
          position={[0.046, -0.676, -0.564]}
          scale={[0.072, 0.072, 0.039]}
        />
        <mesh
          name="Angled_Panel001"
          castShadow
          receiveShadow
          geometry={nodes.Angled_Panel001.geometry}
          material={materials.M_Small_Parts}
          position={[-0.113, -0.676, -0.564]}
          rotation={[0, Math.PI / 3, 0]}
          scale={[0.072, 0.072, 0.039]}
        />
        <mesh
          name="Angled_Panel002"
          castShadow
          receiveShadow
          geometry={nodes.Angled_Panel002.geometry}
          material={materials.M_Small_Parts}
          position={[0.046, -0.676, 0.544]}
          rotation={[0, 0, -Math.PI]}
          scale={[-0.072, -0.072, -0.039]}
        />
        <mesh
          name="Angled_Panel003"
          castShadow
          receiveShadow
          geometry={nodes.Angled_Panel003.geometry}
          material={materials.M_Small_Parts}
          position={[-0.113, -0.676, 0.544]}
          rotation={[0, -Math.PI / 3, -Math.PI]}
          scale={[-0.072, -0.072, -0.039]}
        />
        <mesh
          name="Antenie000"
          castShadow
          receiveShadow
          geometry={nodes.Antenie000.geometry}
          material={materials.M_Small_Parts}
          position={[0.583, -0.495, 0.563]}
          rotation={[-0.786, 0, 0]}
        />
        <mesh
          name="Antenie001"
          castShadow
          receiveShadow
          geometry={nodes.Antenie001.geometry}
          material={materials.M_Small_Parts}
          position={[0.583, -0.495, -0.577]}
          rotation={[0.786, 0, -Math.PI]}
          scale={-1}
        />
        <mesh
          name="Flat_Square_Panel"
          castShadow
          receiveShadow
          geometry={nodes.Flat_Square_Panel.geometry}
          material={materials.M_Small_Parts}
          position={[-0.538, -0.608, 0.516]}
          scale={0.803}
        />
        <mesh
          name="QR_Clamp000"
          castShadow
          receiveShadow
          geometry={nodes.QR_Clamp000.geometry}
          material={materials.M_Small_Parts}
          position={[-0.372, 0.609, 0.035]}
        />
        <mesh
          name="QR_Clamp001"
          castShadow
          receiveShadow
          geometry={nodes.QR_Clamp001.geometry}
          material={materials.M_Small_Parts}
          position={[-0.332, 0.609, 0.002]}
          rotation={[-Math.PI, Math.PI / 3, -Math.PI]}
        />
        <mesh
          name="QR_Clamp002"
          castShadow
          receiveShadow
          geometry={nodes.QR_Clamp002.geometry}
          material={materials.M_Small_Parts}
          position={[-0.381, 0.609, -0.016]}
          rotation={[Math.PI, -Math.PI / 3, Math.PI]}
        />
        <mesh
          name="Right_Angled_Panel000"
          castShadow
          receiveShadow
          geometry={nodes.Right_Angled_Panel000.geometry}
          material={materials.M_Small_Parts}
          position={[0.609, -0.541, -0.217]}
          rotation={[-Math.PI / 2, 0, Math.PI / 2]}
        />
        <mesh
          name="QR_Badge"
          castShadow
          receiveShadow
          geometry={nodes.QR_Badge.geometry}
          material={materials['M_QR_Badge.001']}
          position={[-0.361, 0.695, -0.001]}
        />
        <mesh
          name="Round_Ant000"
          castShadow
          receiveShadow
          geometry={nodes.Round_Ant000.geometry}
          material={materials.M_Small_Parts}
          position={[0.463, -0.634, 0.535]}
          scale={[0.068, 0.012, 0.068]}
        />
        <mesh
          name="Round_Ant001"
          castShadow
          receiveShadow
          geometry={nodes.Round_Ant001.geometry}
          material={materials.M_Small_Parts}
          position={[0.463, -0.634, -0.55]}
          scale={[0.068, 0.012, 0.068]}
        />
        <mesh
          name="Small_Poke000"
          castShadow
          receiveShadow
          geometry={nodes.Small_Poke000.geometry}
          material={materials.M_Small_Parts}
          position={[-0.484, 0.614, -0.026]}
          scale={[0.009, 0.022, 0.009]}
        />
        <mesh
          name="Small_Poke001"
          castShadow
          receiveShadow
          geometry={nodes.Small_Poke001.geometry}
          material={materials.M_Small_Parts}
          position={[-0.511, 0.614, -0.052]}
          scale={[0.009, 0.022, 0.009]}
        />
        <mesh
          name="Small_Poke002"
          castShadow
          receiveShadow
          geometry={nodes.Small_Poke002.geometry}
          material={materials.M_Small_Parts}
          position={[-0.539, 0.614, -0.026]}
          scale={[0.009, 0.022, 0.009]}
        />
        <mesh
          name="Tri_Spike"
          castShadow
          receiveShadow
          geometry={nodes.Tri_Spike.geometry}
          material={materials.M_Small_Parts}
          position={[0.163, 0.643, -0.008]}
        />
        <mesh
          name="Fill_Port000"
          castShadow
          receiveShadow
          geometry={nodes.Fill_Port000.geometry}
          material={materials.M_Small_Parts}
          position={[0.546, 0.322, 0.415]}
          rotation={[0, 0, -Math.PI / 2]}
          scale={[0.011, 0.012, 0.011]}
        />
        <mesh
          name="Fill_Port001"
          castShadow
          receiveShadow
          geometry={nodes.Fill_Port001.geometry}
          material={materials.M_Small_Parts}
          position={[0.544, 0.348, 0.325]}
          rotation={[0, 0, -Math.PI / 2]}
          scale={[0.006, 0.007, 0.006]}
        />
        <mesh
          name="Solar_Panel_Bracket003"
          castShadow
          receiveShadow
          geometry={nodes.Solar_Panel_Bracket003.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, -0.003, 0.015]}
          scale={0.928}
        />
        <mesh
          name="Solar_Panel_Bracket004"
          castShadow
          receiveShadow
          geometry={nodes.Solar_Panel_Bracket004.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, 0.003, 3.057]}
          rotation={[Math.PI, 0, 0]}
          scale={0.928}
        />
        <mesh
          name="Solar_Panel_Bracket005"
          castShadow
          receiveShadow
          geometry={nodes.Solar_Panel_Bracket005.geometry}
          material={materials.M_Small_Parts}
          position={[-0.615, -0.003, -1.142]}
          scale={0.928}
        />
        <mesh
          name="Panel_Pivot000"
          castShadow
          receiveShadow
          geometry={nodes.Panel_Pivot000.geometry}
          material={materials.M_Small_Parts}
          position={[-0.541, 0.001, -0.628]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={[-0.061, -0.025, -0.061]}
        />
        <mesh
          name="Panel_Pivot001"
          castShadow
          receiveShadow
          geometry={nodes.Panel_Pivot001.geometry}
          material={materials.M_Small_Parts}
          position={[-0.541, 0.001, 0.612]}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={[-0.061, -0.025, -0.061]}
        />
        <mesh
          name="Main_Shell"
          castShadow
          receiveShadow
          geometry={nodes.Main_Shell.geometry}
          material={materials.M_Base_Cube}
          position={[-0.615, 0.003, -0.001]}
          rotation={[Math.PI, 0, 0]}
        />
        <mesh
          name="Back_Logo"
          castShadow
          receiveShadow
          geometry={nodes.Back_Logo.geometry}
          material={materials.M_Small_Parts}
          position={[0.55, 0, 0]}
          rotation={[0, 0, -Math.PI / 2]}
        />
        <mesh
          name="Solar_Panel000"
          castShadow
          receiveShadow
          geometry={nodes.Solar_Panel000.geometry}
          material={materials.M_Solar_Panel}
          position={[-0.615, 0.003, -0.031]}
          rotation={[Math.PI, 0, 0]}
          scale={0.928}
        />
        <mesh
          name="Solar_Panel001"
          castShadow
          receiveShadow
          geometry={nodes.Solar_Panel001.geometry}
          material={materials.M_Solar_Panel}
          position={[-0.615, 0.003, 0.549]}
          rotation={[Math.PI, 0, 0]}
          scale={0.928}
        />
        <mesh
          name="Solar_Panel002"
          castShadow
          receiveShadow
          geometry={nodes.Solar_Panel002.geometry}
          material={materials.M_Solar_Panel}
          position={[-0.615, 0.003, 1.127]}
          rotation={[Math.PI, 0, 0]}
          scale={0.928}
        />
        <mesh
          name="Solar_Panel003"
          castShadow
          receiveShadow
          geometry={nodes.Solar_Panel003.geometry}
          material={materials.M_Solar_Panel}
          position={[-0.615, -0.003, 0.015]}
          scale={0.928}
        />
        <mesh
          name="Solar_Panel004"
          castShadow
          receiveShadow
          geometry={nodes.Solar_Panel004.geometry}
          material={materials.M_Solar_Panel}
          position={[-0.615, -0.003, -0.564]}
          scale={0.928}
        />
        <mesh
          name="Solar_Panel005"
          castShadow
          receiveShadow
          geometry={nodes.Solar_Panel005.geometry}
          material={materials.M_Solar_Panel}
          position={[-0.615, -0.003, -1.143]}
          scale={0.928}
        />
        <mesh
          name="Arm_Base"
          castShadow
          receiveShadow
          geometry={nodes.Arm_Base.geometry}
          material={materials.M_Arm}
          position={[0.33, 0.619, -0.382]}
        />
        {/* <group name="Small_Sat" position={[4.003, -0.004, 0.005]}>
          <mesh
            name="Back_Ant"
            castShadow
            receiveShadow
            geometry={nodes.Back_Ant.geometry}
            material={materials.M_Small_Sat}
            position={[0.405, -0.29, -0.263]}
            rotation={[-Math.PI / 2, 0.436, Math.PI / 2]}
          />
          <mesh
            name="Clip000"
            castShadow
            receiveShadow
            geometry={nodes.Clip000.geometry}
            material={materials.M_Small_Sat}
            position={[-0.001, 0.312, 0.212]}
          />
          <mesh
            name="Clip001"
            castShadow
            receiveShadow
            geometry={nodes.Clip001.geometry}
            material={materials.M_Small_Sat}
            position={[-0.001, -0.299, 0.212]}
            rotation={[0, 0, -Math.PI]}
          />
          <mesh
            name="Dock"
            castShadow
            receiveShadow
            geometry={nodes.Dock.geometry}
            material={materials.M_Small_Sat}
            position={[-0.403, 0.006, 0.022]}
            scale={0.919}
          />
          <mesh
            name="Front_Ants"
            castShadow
            receiveShadow
            geometry={nodes.Front_Ants.geometry}
            material={materials.M_Small_Sat}
            position={[-0.119, 0.121, 0.221]}
            rotation={[Math.PI / 2, 0, 0]}
            scale={[0.011, 0.014, 0.011]}
          />
          <mesh
            name="Front_Dock"
            castShadow
            receiveShadow
            geometry={nodes.Front_Dock.geometry}
            material={materials.M_Small_Sat}
            position={[0, 0.005, 0.21]}
          />
          <mesh
            name="Large_Ant000"
            castShadow
            receiveShadow
            geometry={nodes.Large_Ant000.geometry}
            material={materials.M_Small_Sat}
            position={[-0.003, 0.446, -0.001]}
          />
          <mesh
            name="Large_Ant001"
            castShadow
            receiveShadow
            geometry={nodes.Large_Ant001.geometry}
            material={materials.M_Small_Sat}
            position={[-0.003, -0.43, -0.001]}
            rotation={[0, 0, Math.PI]}
          />
          <mesh
            name="Main_Body"
            castShadow
            receiveShadow
            geometry={nodes.Main_Body.geometry}
            material={materials.M_Small_Sat}
            position={[0.003, 0.008, -0.003]}
          />
          <mesh
            name="Panel000"
            castShadow
            receiveShadow
            geometry={nodes.Panel000.geometry}
            material={materials.M_Small_Sat}
            position={[0.369, 0.632, -0.001]}
          />
          <mesh
            name="Panel001"
            castShadow
            receiveShadow
            geometry={nodes.Panel001.geometry}
            material={materials.M_Small_Sat}
            position={[0.369, 1.127, -0.001]}
          />
          <mesh
            name="Panel002"
            castShadow
            receiveShadow
            geometry={nodes.Panel002.geometry}
            material={materials.M_Small_Sat}
            position={[0.369, 1.62, -0.001]}
          />
          <mesh
            name="Panel003"
            castShadow
            receiveShadow
            geometry={nodes.Panel003.geometry}
            material={materials.M_Small_Sat}
            position={[0.369, -0.616, -0.003]}
            rotation={[-Math.PI, 0, 0]}
          />
          <mesh
            name="Panel004"
            castShadow
            receiveShadow
            geometry={nodes.Panel004.geometry}
            material={materials.M_Small_Sat}
            position={[0.369, -1.11, -0.003]}
            rotation={[-Math.PI, 0, 0]}
          />
          <mesh
            name="Panel005"
            castShadow
            receiveShadow
            geometry={nodes.Panel005.geometry}
            material={materials.M_Small_Sat}
            position={[0.369, -1.604, -0.003]}
            rotation={[-Math.PI, 0, 0]}
          />
          <mesh
            name="Panel_Clip000"
            castShadow
            receiveShadow
            geometry={nodes.Panel_Clip000.geometry}
            material={materials.M_Small_Sat}
            position={[0.376, 0.877, 0.101]}
          />
          <mesh
            name="Panel_Clip001"
            castShadow
            receiveShadow
            geometry={nodes.Panel_Clip001.geometry}
            material={materials.M_Small_Sat}
            position={[0.376, 0.877, -0.104]}
          />
          <mesh
            name="Panel_Clip002"
            castShadow
            receiveShadow
            geometry={nodes.Panel_Clip002.geometry}
            material={materials.M_Small_Sat}
            position={[0.361, 1.373, -0.104]}
            rotation={[-Math.PI, 0, -Math.PI]}
          />
          <mesh
            name="Panel_Clip003"
            castShadow
            receiveShadow
            geometry={nodes.Panel_Clip003.geometry}
            material={materials.M_Small_Sat}
            position={[0.361, 1.373, 0.101]}
            rotation={[-Math.PI, 0, -Math.PI]}
          />
          <mesh
            name="Panel_Clip004"
            castShadow
            receiveShadow
            geometry={nodes.Panel_Clip004.geometry}
            material={materials.M_Small_Sat}
            position={[0.361, 0.399, -0.104]}
            rotation={[-Math.PI, 0, -Math.PI]}
          />
          <mesh
            name="Panel_Clip005"
            castShadow
            receiveShadow
            geometry={nodes.Panel_Clip005.geometry}
            material={materials.M_Small_Sat}
            position={[0.361, 0.399, 0.101]}
            rotation={[-Math.PI, 0, -Math.PI]}
          />
          <mesh
            name="Panel_Clip006"
            castShadow
            receiveShadow
            geometry={nodes.Panel_Clip006.geometry}
            material={materials.M_Small_Sat}
            position={[0.376, -0.861, -0.104]}
            rotation={[-Math.PI, 0, 0]}
          />
          <mesh
            name="Panel_Clip007"
            castShadow
            receiveShadow
            geometry={nodes.Panel_Clip007.geometry}
            material={materials.M_Small_Sat}
            position={[0.376, -0.861, 0.101]}
            rotation={[-Math.PI, 0, 0]}
          />
          <mesh
            name="Panel_Clip008"
            castShadow
            receiveShadow
            geometry={nodes.Panel_Clip008.geometry}
            material={materials.M_Small_Sat}
            position={[0.361, -1.357, 0.101]}
            rotation={[0, 0, Math.PI]}
          />
          <mesh
            name="Panel_Clip009"
            castShadow
            receiveShadow
            geometry={nodes.Panel_Clip009.geometry}
            material={materials.M_Small_Sat}
            position={[0.361, -1.357, -0.104]}
            rotation={[0, 0, Math.PI]}
          />
          <mesh
            name="Panel_Clip010"
            castShadow
            receiveShadow
            geometry={nodes.Panel_Clip010.geometry}
            material={materials.M_Small_Sat}
            position={[0.361, -0.383, 0.101]}
            rotation={[0, 0, Math.PI]}
          />
          <mesh
            name="Panel_Clip011"
            castShadow
            receiveShadow
            geometry={nodes.Panel_Clip011.geometry}
            material={materials.M_Small_Sat}
            position={[0.361, -0.383, -0.104]}
            rotation={[0, 0, Math.PI]}
          />
        </group> */}
        <group name="Base" position={[0.329, 1.435, -0.384]} rotation={[Math.PI, 0, Math.PI]}>
          <mesh
            name="Joint000"
            castShadow
            receiveShadow
            geometry={nodes.Joint000.geometry}
            material={materials.M_Arm}
            position={[0, -0.706, 0]}
          />
        </group>
        <group name="J_01" position={[0.329, 0.739, 0.268]} rotation={[Math.PI, 0, Math.PI]}>
          <mesh
            name="Joint001"
            castShadow
            receiveShadow
            geometry={nodes.Joint001.geometry}
            material={materials.M_Arm}
            position={[0, 0, 0.465]}
            rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
          />
        </group>
        <group
          name="J_03"
          position={[-0.251, 0.358, -0.186]}
          rotation={[Math.PI / 2, 0, Math.PI / 2]}>
          <mesh
            name="Bend_Arm"
            castShadow
            receiveShadow
            geometry={nodes.Bend_Arm.geometry}
            material={materials.M_Arm}
            position={[0.18, 0.01, -0.56]}
            rotation={[-Math.PI, Math.PI / 2, 0]}
          />
        </group>
        <group name="J_06" position={[-0.077, 0.761, 0.374]} rotation={[-Math.PI, 1.571, 0]}>
          <mesh
            name="Grabber_Stump"
            castShadow
            receiveShadow
            geometry={nodes.Grabber_Stump.geometry}
            material={materials.M_Arm}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={0.8}
          />
          <mesh
            name="Grabber_Stump001"
            castShadow
            receiveShadow
            geometry={nodes.Grabber_Stump001.geometry}
            material={materials.M_Arm}
            position={[0, 0, 0.081]}
            rotation={[Math.PI / 2, -Math.PI / 2, 0]}
            scale={0.8}
          />
          <mesh
            name="Teeth"
            castShadow
            receiveShadow
            geometry={nodes.Teeth.geometry}
            material={materials.M_Arm}
            position={[0, 0, 0.163]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={1.031}
          />
        </group>
        <group name="J_02" position={[0.038, 0.739, -0.186]} rotation={[Math.PI / 2, 0, Math.PI]}>
          <mesh
            name="Fat_Arm"
            castShadow
            receiveShadow
            geometry={nodes.Fat_Arm.geometry}
            material={materials.M_Arm}
            rotation={[Math.PI, 0, -Math.PI / 2]}
          />
          <mesh
            name="Joint002"
            castShadow
            receiveShadow
            geometry={nodes.Joint002.geometry}
            material={materials.M_Arm}
            position={[0.289, 0, -0.009]}
            rotation={[Math.PI / 2, Math.PI / 2, 0]}
          />
        </group>
        <group name="J_04" position={[-0.253, 0.919, 0.771]} rotation={[-Math.PI, 1.571, 0]}>
          <mesh
            name="Joint003"
            castShadow
            receiveShadow
            geometry={nodes.Joint003.geometry}
            material={materials.M_Arm}
            position={[-0.397, 0.008, 0]}
            rotation={[Math.PI, 1.571, 0]}
            scale={0.8}
          />
        </group>
        <group name="J_05" position={[-0.253, 1.193, 0.374]} rotation={[-Math.PI, 1.571, 0]}>
          <mesh
            name="Joint004"
            castShadow
            receiveShadow
            geometry={nodes.Joint004.geometry}
            material={materials.M_Arm}
            position={[0, 0.432, 0.007]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={0.8}
          />
        </group>
      </group>
    </group>
  )
}
